import tables from './tables';
import utils from '../utils';

const getRecentLaunchOptionsByFilter = async (brandId, orderBy, filterValue, token) => {
  const { data: recentlyUsed } = await utils.getFromMikMakFirebaseService(
    `getById/${tables.recentLaunchOptions}/${brandId}?orderBy=${orderBy}&equalTo=${filterValue}`,
    token,
  );

  return recentlyUsed;
};

const updateRecentLaunchOptions = async (brandId, data, token) => {
  if (!brandId) {
    throw new Error('Error updating recent launch options - no brand specified');
  }

  if (!data) {
    throw new Error('Error updating recent launch options - no data payload');
  }

  await utils.postToMikMakFirebaseService(
    `update/${tables.recentLaunchOptions}/${brandId}`,
    data,
    token,
  );
};

export default {
  getRecentLaunchOptionsByFilter,
  updateRecentLaunchOptions,
};
